export default Object.freeze({
  posthogKey: 'phc_BGvHRT4OVwJESO5OnjR5SUV6JfcBiwgLn8XNG55EExU',
  posthogUiHost: 'https://us.posthog.com',
  posthogApiHost: 'https://posthog.offdeal.io',
  muiProLicense: '9611b246d27be1c42e8eb1e5c72212c0Tz04NTYwNyxFPTE3NDEwNDM1ODgwMDAsUz1wcm8sTE09c3Vic2NyaXB0aW9uLEtWPTI=',
});
